import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account_selected",
  "use": "icon-account_selected-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol viewBox=\"0 0 29 28\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-account_selected\">\n<circle cx=\"14.5\" cy=\"14\" r=\"13.5\" />\n<path d=\"M7.82609 21.6928C10.1312 23.491 13.2047 21.4167 13.8424 18.7481C13.9707 18.211 13.5121 17.7577 12.9664 17.6723C11.1267 17.3841 8.78424 16.405 6.97508 15.3724C6.37078 15.0274 5.58265 15.3347 5.53177 16.0287C5.39905 17.8389 5.81862 20.1268 7.82609 21.6928Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol